import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const DocumnetHelthsecondtab = () => {
     const location = useLocation();
          const searchParams = new URLSearchParams(location.search);
          const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "tab1");
      
          useEffect(() => {
              const tabParam = searchParams.get("tab");
              if (tabParam) {
                  setActiveTab(tabParam);
              }
          }, [location.search]); // Update tab when URL changes
      

    const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreClick = () => {
        navigate("/carrerspage"); // Replace with the actual route you want to navigate to
    };

    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        const tabInterval = setInterval(() => {
            // setActiveTab((prevTab) => {
            //     const nextTabNum = parseInt(prevTab.replace("tab", "")) % 3 + 1; // 9 tabs in total
            //     return `tab${nextTabNum}`;
            // });
        }, 3000); // Change tab every 3 seconds

        // Clear interval when component unmounts
        return () => clearInterval(tabInterval);
    }, []);

    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            flexDirection: "row",
            width: "98%",
            margin: "50px auto",
            justifyContent: "space-between",
        },
        tabNav: {
            // width:"400px",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            // height: "410px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
        },
        // Apply mobile-specific styles for tabNav

        tabButton: {
            padding: "20px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            marginLeft: "10px",
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            marginLeft: "150px"
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        // Mobile styling for tabs above content
        mobileContainer: {
            flexDirection: "column", // Stack tabs and content
        },
        mobileTabNav: {
            flexDirection: "row", // Tabs are horizontal on mobile
            justifyContent: "space-around",
            borderRight: "none", // Remove right border for mobile
        },
        mobileCard: {
            flexDirection: "column", // Stack image and text content
            alignItems: "center",
            textAlign: "center",
        },
        mobileImage: {
            width: "100%",
            height: "auto",
            marginRight: "0", // Remove right margin on mobile
        },
        mobileKnowMoreButton: {
            marginLeft: "0", // Center button on mobile
        },
        // Mobile tab navigation change
        mobileTabButton: {
            padding: "20px",
            fontSize: "14px",
            fontWeight: "normal",
            color: "#555",
            backgroundColor: "#f0f0f0",
            border: "none",
            cursor: "pointer",
            outline: "none",
            textAlign: "center",
        },
        activeMobileTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        }
    };
    const tabContent = {
        tab1: [

            { id: 1, title: " 	What are these standards?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> The Medical Device & Quality Management ISO Standards define international requirements for quality management systems (QMS), risk management, biological safety, and clinical trials for medical devices. These standards ensure that medical devices are safe, effective, and meet global regulatory expectations.<br><br> Key ISO Standards for Medical Devices:  <br><br><b>1.	ISO 13485 – Quality Management System (QMS) for Medical Devices</b> <ul><li>Ensures QMS implementation for medical device manufacturers.</li><li>Covers gap analysis, pre-certification audits, and vendor audits.</li></ul><b> 2.	ISO 14971 – Risk Management for Medical Devices</b><ul><li>Defines risk assessment, mitigation, and monitoring strategies.</li></ul><b>3.	ISO 10993 – Biological Evaluation of Medical Devices</b><ul><li>Ensures biocompatibility testing for medical device materials.</li></ul><b> 4.	ISO 14155 – Clinical Investigation of Medical Devices in Human Subjects </b><ul><li>Sets ethical and scientific guidelines for clinical trials of medical devices.</li></ul>These standards ensure that medical devices comply with global safety, quality, and performance benchmarks." },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> These ISO standards are developed and maintained by the International Organization for Standardization (ISO). </li><b> However, compliance is enforced by medical device regulatory bodies worldwide:</b> <ul><li>U.S. Food and Drug Administration (FDA) – 21 CFR Part 820 (QSR) & ISO 13485.</li><li>European Medicines Agency (EMA) – EU MDR (2017/745) & ISO 13485.</li><li>Medical Device Coordination Group (MDCG) – Enforces ISO 14971 risk management in the EU.</li><li>Central Drugs Standard Control Organization (CDSCO – India) – ISO 13485-based compliance for medical devices.</li><li>World Health Organization (WHO) – Adopts ISO 10993 for global medical device safety.</li></ul>Medical device manufacturers must comply with ISO standards to obtain market approvals in the U.S., EU, India, and other global markets." },
            { id: 3, title: "Who does this apply to?", description: " These ISO standards apply to all medical device manufacturers and related stakeholders, including:  <ul><li>Medical Device Manufacturers & Suppliers </li><li>Medical Equipment & Implantable Device Manufacturers</li><li>In Vitro Diagnostics (IVD) & Lab Equipment Companies</li><li>Software as a Medical Device (SaMD) & AI-based Medical Tech Firms</li><li>Research & Testing Bodies </li><li>Contract Research Organizations (CROs) conducting clinical trials </li><li>Biocompatibility & Risk Management Testing Labs</li><li>Regulatory Consultants & QMS Auditors </li><li>Regulatory & Certification Bodies</li><li>Notified Bodies (EU) & Certification Agencies </li><li>ISO 13485-certified QMS Auditors </li></ul> Any entity involved in the development, testing, and regulation of medical devices must comply with these ISO standards." },
            { id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>✅</span>
        <span>Yes, ISO compliance is mandatory for medical device manufacturers seeking regulatory approvals in most global markets.</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span>🚨</span>
        <span>Regulatory rejection of medical devices (No CE Marking, No FDA Clearance).</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🚨</span>
        <span>Legal liabilities and financial penalties.</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🚨</span>
        <span>Product recalls due to non-compliant risk management or safety testing.</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🚨</span>
        <span>Inability to sell medical devices in global markets.</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        
        <span>ISO 13485 compliance is required for medical device companies to obtain approvals under FDA (U.S.), EU MDR (Europe), CDSCO (India), and WHO guidelines.</span>
    </li>
</ul>
` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Audits are required regularly to ensure continuous compliance with ISO medical device standards.</li> <br> Typical Audit Frequency: <ul><li>ISO 13485 Certification Audit (Every 3 Years) – Full QMS certification audit.</li><li>Annual Surveillance Audits (Every 12 Months) – Required to maintain ISO 13485 certification.</li><li>ISO 14971 Risk Management Audits (Every 1-2 Years) – Conducted for medical device risk assessment.</li><li>Biological Safety Audits (ISO 10993) – Per Device Lifecycle – Testing for new devices/materials.</li><li>Clinical Trial Compliance Audits (ISO 14155) – Per Study Phase – Ensuring adherence to ethical trial guidelines. </li></ul> Medical device companies should integrate ISO audits with FDA and EU MDR regulatory inspections." },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> Each ISO standard has specific compliance requirements for medical device quality, risk management, and safety. <br><br><b> 1. ISO 13485 – Quality Management System (QMS) for Medical Devices </b><ul><li> Implementation of a documented QMS for medical device manufacturing. </li><li>Supplier & Vendor Qualification Audits to ensure supply chain quality.</li><li>Product Traceability & Complaint Handling Procedures.</li></ul><b> 2. ISO 14971 – Risk Management for Medical Devices</b><ul><li>Risk Analysis, Evaluation, and Mitigation Plans throughout the device lifecycle.</li><li>Hazard Identification & Failure Mode and Effects Analysis (FMEA).</li><li>Post-Market Surveillance & Incident Reporting.</li></ul><b> 3. ISO 10993 – Biological Evaluation of Medical Devices </b><ul><li>Material Toxicity Testing & Biocompatibility Studies.</li><li>In Vivo & In Vitro Safety Testing for Device Components.</li><li>Chemical Characterization of Medical Device Materials.</li></ul><b> 4. ISO 14155 – Clinical Investigation of Medical Devices </b><ul><li>Ethical Conduct of Human Clinical Trials. </li><li>Data Integrity & Adverse Event Reporting in Clinical Studies.</li><li>Good Clinical Practice (GCP) Compliance for Device Trials. </li></ul>  Compliance with these ISO standards ensures product quality, patient safety, and regulatory acceptance. " },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `The official ISO medical device standards can be accessed at: <br><br>
              📌 Official Source:
   <ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 13485 – Medical Device Quality Management System (QMS)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 13485 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 14971 – Risk Management for Medical Devices</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 14971 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 10993 – Biological Evaluation of Medical Devices</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 10993 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 14155 – Clinical Investigation of Medical Devices in Humans</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 14155 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>EU MDR (2017/745) Medical Device Regulations</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>EU MDR Official Link</span>
    </li>
</ul>

        Medical device companies should integrate ISO compliance with EU MDR, FDA QSR, and WHO-GMP requirements.
                `
            },
        ],
        tab2: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li> The Healthcare Management & Patient Safety Standards include ISO 9001, ISO 45001, and ISO 22870, which establish quality management, occupational health and safety, and laboratory compliance for healthcare organizations. These standards focus on patient safety, staff well-being, and clinical service efficiency.</li><b>Key ISO Standards for Medical Devices: </b> <br><b>1.	ISO 9001 – Quality Management System (QMS) for Healthcare</b><ul><li>Focuses on staff well-being and workplace safety in hospitals.</li><li>Covers gap analysis, pre-certification audits, and vendor audits.</li></ul><b>2.	ISO 45001 – Occupational Health & Safety Management System (OHSMS)</b><ul><li>Defines risk assessment, mitigation, and monitoring strategies.</li></ul><b> 3.	ISO 22870 – Point-of-Care Testing (POCT) Compliance</b><ul><li>Ensures biocompatibility testing for medical device materials.</li></ul>These ISO standards ensure that healthcare services maintain high safety, quality, and efficiency levels." },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> These ISO standards are developed and maintained by the International Organization for Standardization (ISO).</li> However, compliance is enforced by medical device regulatory bodies worldwide:<ul><li>Joint Commission International (JCI) – Accredits hospitals and healthcare facilities globally.</li><li>World Health Organization (WHO) – Recommends ISO 9001 & ISO 45001 for global healthcare safety.</li><li>National Accreditation Board for Hospitals & Healthcare Providers (NABH – India) – Requires ISO 9001 compliance for hospital quality accreditation. </li><li>Occupational Safety and Health Administration (OSHA – U.S.) – Aligns with ISO 45001 for workplace safety in healthcare. </li></ul><li> Hospitals and medical laboratories must comply with these standards to ensure high-quality patient care and staff safety.</li></ul>" },
            { id: 3, title: "Who does this apply to?", description: " These ISO standards apply to all healthcare providers, diagnostic labs, and medical organizations that deliver patient care and medical testing. <ul><li> Healthcare Organizations & Hospitals </li><li>Hospitals & Clinics (public and private)</li><li>Specialty & Multispecialty Healthcare Centers</li><li>Home Healthcare & Telemedicine Providers </li><li>Healthcare Staff & Occupational Safety Programs</li><li>Doctors, Nurses, and Medical Professionals</li><li>Hospital Administrators & Safety Officers</li><li>Emergency & Ambulance Services</li><li>Medical Laboratories & Diagnostic Testing Centers </li><li>Pathology Labs & Clinical Testing Facilities</li><li> Point-of-Care Testing (POCT) Units (e.g., bedside glucose monitoring, rapid tests) </li></ul>Any healthcare provider or diagnostic center aiming for quality certification must comply with these ISO standards." },
            { id: 4, title: "Is compliance mandatory?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;'></span> Compliance with ISO 9001, ISO 45001, and ISO 22870 is not legally mandatory in all regions but is highly recommended for healthcare organizations seeking global accreditation and patient safety certifications. <br><br><b> Mandatory Compliance in Specific Cases:</b> <ul><li> ISO 9001 is required for JCI and NABH hospital accreditation.</li><li>ISO 45001 aligns with OSHA (U.S.) and EU workplace safety laws for healthcare workers.</li><li>ISO 22870 compliance is necessary for POCT labs to meet regulatory standards.</li></ul>Consequences of Non-Compliance:Loss of hospital accreditation (JCI, NABH, CAP, etc.). <ul><li> Legal and financial liabilities for unsafe healthcare practices. </li><li>Increased patient safety risks and reputational damage. </li></ul>Compliance with these ISO standards enhances healthcare quality, patient safety, and regulatory approvals." },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Healthcare organizations must conduct regular audits to maintain compliance with these ISO standards.</li><b>Typical Audit Frequency for Healthcare ISO Standards:</b> <ul><li>ISO 9001 Certification Audit (Every 3 Years) – Full QMS certification for hospitals.</li><li>ISO 9001 Surveillance Audits (Annual) – Required to maintain certification.</li><li>ISO 45001 Safety Audits (Annual or Biannual) – Workplace safety inspections.</li></ul> Accredited hospitals and diagnostic labs must undergo regular quality and safety inspections to maintain ISO certification." },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> Each ISO standard outlines specific compliance requirements to ensure safe, high-quality, and efficient healthcare services. <br><br><b> 1. ISO 9001 – Healthcare Quality Management System (QMS) </b><ul><li> Establish hospital-wide quality management policies.</li><li>Monitor patient satisfaction and feedback for improvement.</li></ul><b> 2. ISO 45001 – Occupational Health & Safety in Healthcare</b><ul><li>Ensure a safe work environment for healthcare staff.</li><li>Implement infection control and hazard prevention measures.</li><li>Provide emergency response plans for hospital safety.</li></ul><b>3. ISO 22870 – Point-of-Care Testing (POCT) Compliance</b><ul><li>Standardize procedures for rapid diagnostic tests outside laboratories.</li><li>Ensure accuracy and reliability of bedside medical tests.</li><li>Train healthcare workers on proper POCT methods.</li></ul>Hospitals and diagnostic labs must maintain detailed records, training programs, and risk management strategies to meet these ISO standards." },

            {
                id: 7,
                title: "The official ISO healthcare management and patient safety standards can be accessed at:",
                description: `The official ISO medical device standards can be accessed at: <br><br>
  <ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>Official Source:</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 9001 – Healthcare Quality Management System (QMS)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 9001 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 45001 – Occupational Health & Safety in Healthcare</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 45001 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 22870 – Point-of-Care Testing (POCT) Compliance</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 22870 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>WHO Healthcare Quality & Patient Safety Guidelines</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>WHO Patient Safety Link</span>
    </li>
</ul>

    Hospitals should integrate ISO compliance with WHO, JCI, and NABH accreditation requirements for enhanced healthcare service quality.      
     `
            },
        ],
        tab3: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li>The Health Informatics & Data Security Standards ensure cybersecurity, privacy, and interoperability of electronic health records (EHRs) and IT infrastructure in healthcare. These standards are essential for protecting patient data, ensuring compliance with global regulations, and maintaining secure healthcare systems. </li><b> Key ISO Standards for Healthcare IT Security:</b>  <br><b>1.	ISO 27799 – Information Security Management for Health Organizations</b><ul><li>Extends ISO 27001 to healthcare environments.</li><li>Provides cybersecurity controls for healthcare data protection.</li></ul><b> 2.	ISO 13606 – Electronic Health Record (EHR) Communication Compliance</b><ul><li>Defines risk assessment, mitigation, and monitoring strategies.</li></ul> 🔹 These standards ensure that healthcare organizations maintain a high level of cybersecurity and interoperability for EHRs." },

            { id: 2, title: "Who is the regulatory body?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> These ISO standards are developed by the International Organization for Standardization (ISO) and enforced by national and international healthcare cybersecurity regulators: <br><br> 🔹 ISO/IEC (International Organization for Standardization) – Develops ISO 27799 & ISO 13606 standards. <br><br>🔹  Health Level Seven International (HL7) – Develops FHIR & HL7 interoperability standards for health data exchange. <br><br> 🔹  U.S. Department of Health and Human Services (HHS) – HIPAA (Health Data Security). <br><br>🔹  European Data Protection Board (EDPB) – GDPR Compliance for Healthcare Data. <br><br> 🔹  Central Drugs Standard Control Organization (CDSCO – India) – ISO 13485-based compliance for medical devices. <br><br>🔹  World Health Organization (WHO) – Adopts ISO 10993 for global medical device safety. <br><br> 💡 Compliance with ISO 27799 and ISO 13606 is critical for aligning healthcare data security with regulatory laws like HIPAA (U.S.), GDPR (EU), and national health IT regulations." },
            { id: 3, title: "Who does this apply to?", description: " These standards apply to all organizations handling electronic health records (EHRs) and patient data in healthcare IT infrastructure. <ul><li>Healthcare Organizations & IT Systems</li><li>Hospitals, Clinics, and Health Networks</li><li>Electronic Health Record (EHR) Providers </li><li>Health Information Exchange (HIE) Platforms </li><li>Digital Health & Medical Software Developers</li><li>Telemedicine & AI-driven Health Analytics</li><li>Mobile Health Apps & Remote Patient Monitoring,/li><li>Research & Healthcare Data Processing Entities</li><li>Clinical Trial & Research Data Platforms</li><li>Health Insurance & Government Digital Health Initiatives</li></ul>🔹 Any organization storing, processing, or exchanging electronic health data must comply with these standards. " },
            { id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: center; gap: 12px;">
        <span style="; display: inline-block; text-align: flex-start;">✅</span>
        <span>Yes, compliance with ISO 27799 & ISO 13606 is highly recommended for healthcare IT security and interoperability.</span>
    </li>
</ul>
                Regulatory Laws Mandating Healthcare IT Security Compliance: <ul><li>HIPAA (U.S.) – Requires EHR security compliance aligned with ISO 27799. </li><li>GDPR (EU) – Mandates health data protection aligned with ISO cybersecurity frameworks.</li><li>Ayushman Bharat Digital Mission (India) – Requires EHR interoperability based on ISO 13606.</li><li>EU Digital Health Standards – Support secure EHR communication under ISO 13606 & HL7 FHIR.</li></ul><b>Consequences of Non-Compliance:</b><br> <ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🚨</span>
        <span>Data breaches leading to HIPAA/GDPR fines up to $1.5M (€20M for GDPR violations).</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 8px;">
        <span>🚨</span>
        <span>Cybersecurity attacks and loss of patient trust.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 8px;">
        <span>🚨</span>
        <span>Regulatory bans preventing EHR systems from being used in hospitals.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        
        <span>ISO compliance ensures patient data privacy, cybersecurity risk management, and regulatory approval for digital health systems.</span>
    </li>
</ul>
`},
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Audit Frequency for Health Informatics Security: </li><ul><li>ISO 27799 Security Audits (Annual or Biannual) – Evaluates IT infrastructure risk management.</li><li>ISO 13606 EHR Interoperability Audits (Every 2 Years) – Ensures compliance with FHIR/HL7 data exchange. </li><li>HIPAA Security Risk Assessments (Annual Mandatory for U.S. Healthcare Providers).</li><li>GDPR Data Privacy Audits (As Required by EU Regulators).</li><li>Third-Party Cloud Security Compliance Audits (Quarterly Recommended for SaaS Healthcare Apps). </li></ul></ul> Routine security audits and risk assessments help prevent healthcare cyber threats and regulatory penalties." },
            { id: 6, title: "What are the key requirements?", description: "  <b> 1. ISO 27799 – Information Security in Healthcare IT</b> <ul><li>Cybersecurity Risk Management for Health IT Networks.</li><li>Encryption & Access Control for Electronic Health Records (EHRs).</li><li>Incident Response Plans & Data Breach Reporting.</li></ul><b>2. ISO 13606 – Electronic Health Record (EHR) Compliance</b><ul><li>Standardized EHR Structure & Secure Data Exchange.</li><li>Interoperability & Compatibility with HL7/FHIR Standards</li><li>Authentication & Access Management for Patient Data Sharing. </li></ul><b> 3. HIPAA & GDPR Healthcare IT Security Compliance</b><ul><li>HIPAA Privacy & Security Rules for U.S. Health Data.</li><li>GDPR Data Protection & Cross-Border Data Transfer Restrictions.</li><li>Audit Trails & Role-Based Access (RBAC) for Health Data.</li></ul>  Healthcare IT providers should integrate ISO 27799 with ISO 27001 cybersecurity frameworks for comprehensive compliance." },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `The official ISO healthcare IT security and informatics standards can be accessed at: <br><br>
              📌 Official Source:
    <ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 27799 – Health Information Security (Aligned with ISO 27001)</span>
    </li>
    <li style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
        <span>🔗</span>
        <span>ISO 27799 Official Link</span>
    </li>

    <li style="display: flex; align-items: center; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 13606 – EHR Interoperability Compliance</span>
    </li>
    <li style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
        <span>🔗</span>
        <span>ISO 13606 Official Link</span>
    </li>

    <li style="display: flex; align-items: center; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>HIPAA Compliance (U.S. Department of Health & Human Services - HHS)</span>
    </li>
    <li style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
        <span>🔗</span>
        <span>HIPAA Official Regulations</span>
    </li>

    <li style="display: flex; align-items: center; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>GDPR Compliance for Healthcare (European Commission)</span>
    </li>
    <li style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
        <span>🔗</span>
        <span>GDPR Healthcare Guidelines</span>
    </li>

    <li style="display: flex; align-items: center; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>HL7 FHIR – Health Data Interoperability Standards</span>
    </li>
    <li style="display: flex; align-items: center; gap: 10px; margin-top: 5px;">
        <span>🔗</span>
        <span>HL7 FHIR Standard</span>
    </li>
</ul>

Healthcare IT providers should align compliance with ISO 27799, HIPAA, GDPR, and HL7/FHIR interoperability standards.<br>

Medical device companies should integrate ISO compliance with EU MDR, FDA QSR, and WHO-GMP requirements. 
                `
            },
        ],
        tab4: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li> The Pharmaceuticals & Biotech Standards include ISO 15378 and ISO 16679, which define Good Manufacturing Practices (GMP) for pharmaceutical packaging materials and tamper-proof packaging regulations. These standards ensure that medicines are securely packaged, contamination-free, and meet global regulatory requirements.</li><b> Key ISO Standards for Medical Devices:  </b><br><b>1.	ISO 15378 – GMP for Primary Packaging Materials in Pharmaceuticals</b> <ul><li>Establishes GMP compliance for packaging material manufacturers.</li><li>Covers supplier audits, quality control, and contamination prevention.</li></ul><b> 2.	ISO 16679 – Tamper-Proof Packaging for Pharmaceuticals</b> <ul><li>Defines inspection and advisory processes for tamper-proof packaging.</li></ul>These standards are crucial for ensuring the integrity and safety of pharmaceutical products during manufacturing, distribution, and storage." },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li> These ISO standards are developed by the International Organization for Standardization (ISO) and enforced by various pharmaceutical regulatory agencies worldwide: </li><ul><li>  International Organization for Standardization (ISO) – Maintains ISO 15378 & ISO 16679 standards. </li><li> U.S. Food and Drug Administration (FDA) – Enforces GMP regulations under 21 CFR Part 210 & 211.</li><li> European Medicines Agency (EMA) – EU MDR (2017/745) & ISO 13485. </li><li> Medical Device Coordination Group (MDCG) – Enforces ISO 14971 risk management in the EU. </li><li> Central Drugs Standard Control Organization (CDSCO – India) – ISO 13485-based compliance for medical devices. </li><li>World Health Organization (WHO) – Adopts ISO 10993 for global medical device safety. </li></ul> Pharmaceutical companies must comply with these packaging standards to obtain regulatory approvals in the U.S., EU, India, and other international markets." },
            { id: 3, title: "Who does this apply to?", description: " These ISO standards apply to all organizations involved in the manufacturing, testing, and supply of pharmaceutical packaging materials.<ul><li>Pharmaceutical & Biotech Companies</li><li>Medical Equipment & Implantable Device Manufacturers</li><li>In Vitro Diagnostics (IVD) & Lab Equipment Companies</li><li>Software as a Medical Device (SaMD) & AI-based Medical Tech Firms </li><li>Research & Testing Bodies</li><li>Contract Research Organizations (CROs) conducting clinical trials </li><li>Biocompatibility & Risk Management Testing Labs</li><li>Regulatory Consultants & QMS Auditors </li><li>Regulatory & Certification Bodies</li></ul>Any entity involved in pharmaceutical packaging, labeling, or GMP compliance must follow these ISO standards." },
            { id: 4, title: "Is compliance mandatory?", description:  `<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: center; gap: 12px;">
        <span style="font-size: 18px; display: inline-block; text-align: flex-start;">✅</span>
        <span>Yes, ISO 15378 & ISO 16679 compliance is mandatory for pharmaceutical manufacturers and packaging suppliers in regulated markets.</span>
    </li>
</ul>
 
                Regulatory Compliance for Pharmaceutical Packaging: <ul><li> FDA – 21 CFR Part 210 & 211 (U.S.) – Requires GMP packaging compliance.</li><li>EU GMP Annex 1 & Annex 9 (Europe) – Regulates primary packaging materials.</li><li>WHO GMP Guidelines – Global GMP Compliance for Medicines.</li><li>Indian Drugs & Cosmetics Act – Schedule M (CDSCO Compliance).</li></ul><b>Consequences of Non-Compliance: </b><ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Regulatory penalties and product recalls.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Market bans for non-compliant pharmaceutical packaging.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Legal liabilities and reputational damage.</span>
    </li>
</ul>

Ensuring compliance with GMP packaging standards is essential for regulatory approvals and global market access.
` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li>Typical Audit Frequency for Pharmaceutical Packaging Compliance: </li><ul><li>ISO 15378 Certification Audits (Every 3 Years) – Full GMP certification for packaging material manufacturers.</li><li>Annual GMP Supplier Audits – Ensures compliance with ISO 15378 & WHO GMP standards.</li><li>Regulatory Inspections (Random or Risk-Based Audits) – Conducted by FDA, EMA, CDSCO, and WHO</li><li>Tamper-Proof Packaging Compliance Audits (ISO 16679 – Every 2 Years) – Ensures anti-counterfeiting measures are in place.</li><li>Internal Quality Audits (Quarterly Recommended) – For ongoing GMP compliance.</li></ul> Routine audits help maintain GMP compliance and prevent packaging failures or regulatory penalties." },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> Each ISO standard includes specific compliance requirements to ensure safe and effective pharmaceutical packaging. <br> 1. ISO 15378 – GMP Compliance for Primary Packaging Materials  <ul><li>Supplier Qualification & Material Quality Testing.</li><li>Hygienic Manufacturing & Contamination Control.</li><li>Batch Traceability & Serialization for Regulatory Compliance.</li></ul>2. ISO 16679 – Tamper-Proof Pharmaceutical Packaging <ul><li>Packaging Integrity Testing & Anti-Counterfeiting Measures.</li><li>Inspection & Compliance for Secure Drug Packaging.</li><li>Regulatory Labeling & Serialization for Market Approval.</li></ul>3. GMP Compliance for Pharmaceutical Packaging (WHO/FDA/EMA) <ul><li>Environmental Controls & Cleanroom Packaging Standards.</li><li>Packaging Material Stability & Compatibility Testing. </li><li>Proper Storage, Transportation, and Handling of Medicines.</li></ul> Pharmaceutical manufacturers must integrate ISO 15378 with global GMP standards (FDA, EMA, WHO) to ensure compliance." },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `The official ISO pharmaceutical packaging standards can be accessed at: <br><br>
              📌 Official Source:
    <ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 15378 – GMP for Primary Packaging Materials</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 15378 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>ISO 16679 – Tamper-Proof Packaging Compliance</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>ISO 16679 Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>FDA GMP Regulations for Pharmaceutical Packaging (21 CFR Part 210 & 211)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>FDA GMP Official Regulations</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>WHO GMP Guidelines for Pharmaceutical Packaging Compliance</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>WHO GMP Guidelines</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>EU GMP Annex 1 & Annex 9 – Pharmaceutical Packaging Compliance</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>EMA GMP Annex Guidelines</span>
    </li>
</ul>

Pharmaceutical companies should align ISO 15378 & ISO 16679 compliance with global GMP regulations for secure packaging and market approval
ments. 
                `
            },
        ],
        tab5: [

            { id: 1, title: " 	What are these standards?", description: "<ul><li> The Payment Card Industry Data Security Standard (PCI DSS) is a global security framework designed to protect cardholder data and prevent payment fraud. In the healthcare industry, PCI compliance is critical for securing credit card transactions used for medical services, telemedicine payments, health insurance, and hospital billing systems. </li><ul><li>PCI DSS establishes guidelines for secure payment processing, encryption, and vulnerability management to ensure that healthcare providers and insurance companies protect patient payment data.</li><li>PCI DSS helps prevent data breaches, fraud, and identity theft in healthcare financial transactions.</li></ul></ul>" },

            { id: 2, title: "Who is the regulatory body?", description: "<ul><li>PCI DSS is regulated and maintained by the Payment Card Industry Security Standards Council (PCI SSC), a collaboration of major credit card companies, including: </li><ul><li>Visa</li><li> Mastercard</li><li>American Express</li><li>Discover </li><li>JCB International</li></ul>Other regulatory bodies overseeing healthcare payment security include: <br><br> U.S. Department of Health & Human Services (HHS) – HIPAA Compliance for Patient Financial Data <br> European Data Protection Board (EDPB) – GDPR for Payment Data in Healthcare <br><br> Healthcare organizations processing card payments must comply with PCI DSS in addition to HIPAA and GDPR." },
            { id: 3, title: "Who does this apply to?", description: "PCI compliance applies to all healthcare entities that process, store, or transmit payment card data, including: <ul><li>Healthcare Providers & Payment Systems</li><li>Hospitals, Clinics & Medical Centers accepting card payments</li><li>Telemedicine & Digital Health Payment Portals</li><li>Health Insurance Companies & Online Claim Payment Services</li><li>Medical Billing & Payment Processors </li><li>Third-Party Billing & Revenue Cycle Management (RCM) Companies</li><li>Electronic Health Record (EHR) Systems with Payment Processing Integration</li><li>Pharmacy & Healthcare Retail </li><li>Pharmacies & Online Medicine Stores Handling Card Transactions </li><li>Healthcare Mobile Payment Apps & Subscription-Based Services </li></ul> Any organization handling payment card data in healthcare must comply with PCI DSS. " },
            { id: 4, title: "Is compliance mandatory?", description: `<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items:flex-start; gap: 12px;">
        <span style=" display: inline-block; text-align: flex-start;">✅</span>
        <span>Yes, PCI DSS compliance is mandatory for all healthcare providers, pharmacies, and digital health platforms that accept, process, or store cardholder data.</span>
    </li>
</ul>

<br><b>Consequences of Non-Compliance:</b>
<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Fines up to $500,000 per security breach.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Loss of the ability to process credit/debit card payments.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Regulatory actions from PCI SSC, HIPAA, and GDPR authorities.</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">🚨</span>
        <span>Data breaches leading to reputational damage and legal action.</span>
    </li>
</ul>

<br>Non-compliance with PCI DSS can lead to data breaches that expose patient financial data and result in severe penalties.
` },
            { id: 5, title: "How often is an audit required?", description: "<ul><li> Typical PCI DSS Audit Frequency in Healthcare: </li><ul><li>Annual PCI DSS Compliance Validation – For all healthcare payment processors.</li><li>Quarterly Vulnerability Scans – Required for Level 1 & 2 healthcare merchants.</li><li>Annual Penetration Testing & Risk Assessments – Ensures network security.</li><li>HIPAA & GDPR Combined Security Audits (Every 12-24 Months) – Ensures compliance with multiple data protection laws.</li><li>Continuous Network Monitoring & Log Analysis – Prevents payment fraud. </li></ul> Healthcare organizations should integrate PCI DSS audits with HIPAA security risk assessments for full compliance.</ul>" },
            { id: 6, title: "What are the key requirements?", description: "<span style='font-size: 24px; display: inline-block; text-align: center; position: relative; top: 5px;margin-left:-14px'>*</span> PCI DSS compliance for healthcare requires technical, operational, and policy-based security measures. <br>1. Secure Network & Systems <ul><li>Implement firewalls and intrusion prevention systems (IPS).</li><li>Protect healthcare payment systems from cyber threats.</li></ul> 2. Cardholder Data Protection<ul><li>Encrypt cardholder data in healthcare payment systems.</li><li>Avoid storing sensitive payment authentication data (e.g., CVV codes).</li></ul>3. Vulnerability Management Program <ul><li>Perform regular security patching for healthcare IT systems.</li><li>Implement anti-malware protection & network scanning.</li></ul>4. Information Security Policies (IS Policy) <ul><li>Establish security policies for patient payment data.</li><li>Train healthcare staff on secure payment processing practices.</li></ul>5. Periodic Penetration Testing & Secure Audits <ul><li>Conduct penetration testing for hospital payment portals. </li><li>Perform PCI DSS compliance audits annually.</li></ul> Healthcare organizations should align PCI DSS security controls with HIPAA (for patient financial data) and GDPR (for data privacy)." },

            {
                id: 7,
                title: " 	Where can I find the official standard documentation?",
                description: `The official PCI DSS compliance guidelines for healthcare organizations can be accessed at: <br><br>
              📌 Official Source:
<ul style="list-style: none; padding: 0; margin: 0;">
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>PCI DSS Official Standards (Payment Card Industry Security Standards Council - PCI SSC)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap:12px;">
        <span>🔗</span>
        <span>PCI DSS Official Link</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>HIPAA & PCI Compliance for Healthcare Payments (HHS)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>HIPAA & PCI Compliance</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>GDPR Compliance for Payment Security in Healthcare (European Commission)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>GDPR Healthcare Payments</span>
    </li>

    <li style="display: flex; align-items: flex-start; gap: 12px; margin-top: 12px;">
        <span style="font-size: 18px;">📌</span>
        <span>RBI PCI Compliance Guidelines for Digital Payments (India)</span>
    </li>
    <li style="display: flex; align-items: flex-start; gap: 12px;">
        <span>🔗</span>
        <span>RBI PCI Guidelines</span>
    </li>
</ul>

      Hospitals, clinics, and medical billing companies should integrate PCI DSS with HIPAA, GDPR, and RBI payment security guidelines.
                `
            },
        ],

    };

    const [toggle, setToggle] = useState(null);

    const updateToggle = (id) => {
        setToggle(toggle === id ? null : id);
    };
    return (
        <div style={{ marginTop: '100px' }}>

            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>(ISO & PCI)   </span>Standards FAQ's
            </h1>
            <div style={{ ...styles.container, ...(window.innerWidth <= 768 ? styles.mobileContainer : {}) }} className="aeroducoment-data">
                {/* Tab Navigation */}
                <div style={{ ...styles.tabNav, ...(window.innerWidth <= 768 ? styles.mobileTabNav : {}) }} className="bfsa-nav-data-tab">
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab1" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab1")}
                    
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab1") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab1") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                        Medical Devices & Quality Management ISO Standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab2" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab2")}
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab2") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab2") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                       Healthcare Management & Patient Safety standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab3" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab3")}
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab3") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab3") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                        Health Informatics & Data Security standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab4" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab4")}
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab4") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab4") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                       Pharmaceuticals & Biotech standards
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(window.innerWidth <= 768 ? styles.mobileTabButton : {}),
                            ...(activeTab === "tab5" ? styles.activeTabButton : {}),
                        }}
                        onClick={() => handleTabClick("tab5")}
                    className="tab-button-width"
                    onMouseEnter={(e) => {
                        if (activeTab !== "tab5") {
                            e.currentTarget.style.backgroundColor = "#000"; // Change background to black
                            e.currentTarget.style.color = "#fff"; // Change text to white
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (activeTab !== "tab5") {
                            e.currentTarget.style.backgroundColor = ""; // Revert background
                            e.currentTarget.style.color = ""; // Revert text color
                        }
                    }}
                    >
                        PCI standards
                    </button>
                </div>

                {/* Tab Content */}
                <div
                    style={{
                        ...styles.card,
                        ...(window.innerWidth <= 768 ? styles.mobileCard : {}),
                        // height: toggle ? "auto" : "450px", 
                        // maxHeight: toggle ? "870px" : "450px",
                        transition: "max-height 0.3s ease", // Transition for smooth expansion
                        overflowY: "auto", // Enable vertical scrolling when content overflows
                        paddingTop: "20px", // Padding to prevent content from sticking to the top
                    }}
                    className="aero-card-data"
                 >
                    <div className="list-tab data-list-tab" style={{ width: "100%", padding: 0,  gap: "20px", flexWrap: "wrap" }}>
                        {tabContent[activeTab].map(({ id, title, description }, index) => (
                             <div
                             key={id}
                             className="mb-3"
                             style={{
                                 width: "100%",
                                 flexWrap: "wrap",
                                //  marginTop:
                                //      window.innerWidth > 768 && // Apply only for large screens (adjust breakpoint as needed)
                                //      (((toggle === 1 || toggle === 2) && (id === 1 || id === 2))
                                //          )
                                //          ? "260px"
                                //          : "0",
                             }}
                         >
                                {/* Clickable Title */}
                                <div
                                    className="p-3 rounded cursor-pointer d-flex justify-content-between align-items-center bg-light"
                                    onClick={() => updateToggle(id)}  // Enable toggle for all items, including id: 1
                                    style={{
                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",  // Apply same box shadow to all items
                                        width: "100%",
                                        position: "relative",  // Set the title position to relative
                                        zIndex: 1,  // Ensure title stays on top of the expanded description
                                    }}
                                >
                                    <span
                                        className="fw-bold"
                                        style={{
                                            fontFamily: "Roboto",
                                            textAlign: "center",
                                            fontSize: "20px",
                                            color: "#000",  // Apply the same color to all items
                                            fontFamily: '"Helvetica Neue", Arial, sans-serif',
                                        }}
                                    >
                                        {title}
                                    </span>
                                    <span style={{ fontSize: "20px" }}>
                                        {toggle === id ? "-" : "+"} {/* Toggle + or - */}
                                    </span>
                                </div>

                                {/* Conditionally Render Description Below When Clicked */}
                                {toggle === id && (
                                    <div className="p-3 mt-2 bg-light rounded" style={{ width: "100%", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",  textAlign: "justify" }}>
                                        <span dangerouslySetInnerHTML={{ __html: description }} />
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Dot Navigation for 3 Tabs */}

        </div>
    );
};

export default DocumnetHelthsecondtab;
